import { useState, useEffect, useContext } from "react";
import { ProfileContext } from "../../../store/ProfileProvider";

const Clock = () => {
  const [time, setTime] = useState<string>("");
  const [utcOffset, setUtcOffset] = useState<string>("");
  const { profileTimeZone } = useContext(ProfileContext);

  useEffect(() => {
    let animationFrameId: any;

    const updateClock = () => {
      const now = new Date();
      const options: Intl.DateTimeFormatOptions = { timeZone: profileTimeZone };

      const day = now.toLocaleString("en-US", { day: "numeric", ...options });
      const month = now.toLocaleString("en-US", { month: "short", ...options });
      const year = now.toLocaleString("en-US", { year: "numeric", ...options });
      const formattedTime = now.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        ...options,
      });

      setTime(`${day} ${month} ${year} · ${formattedTime}`);

      // Get correct UTC offset
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: profileTimeZone,
        timeZoneName: "longOffset",
      });

      const parts = formatter.formatToParts(now);
      const offsetPart = parts.find((part) => part.type === "timeZoneName");

      if (offsetPart) {
        // Replace "GMT" with "UTC" to match expected format
        setUtcOffset(offsetPart.value.replace("GMT", "UTC"));
      }

      const nextSecond = 1000 - now.getMilliseconds();
      animationFrameId = setTimeout(updateClock, nextSecond);
    };

    updateClock();

    return () => clearTimeout(animationFrameId);
  }, [profileTimeZone]);

  return (
    <div>
      {/* <div className="flex flex-col items-end">
        <div className="text-xs font-semibold text-navy-700">
          {time}
          <span className="ml-2">
            {utcOffset === "UTC"
              ? "UTC+00:00"
              : profileTimeZone + " (" + utcOffset + ")"}
          </span>
        </div>
      </div> */}

      <div className="mt-1 flex items-center gap-1 text-xs text-gray-800">
        <span className="font-medium tracking-tighter">
          {time} (
          {utcOffset === "UTC"
            ? "UTC+00:00"
            : `${profileTimeZone.split("/").pop()}, ${utcOffset}`}
          )
        </span>
      </div>
    </div>
  );
};

export default Clock;
